import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
// import { ManageLibraryComponent } from '../../../../manage-library/manage-library.component'


@Component({
  selector: 'atw-frame-blank-config',
  templateUrl: './frame-blank-config.component.html',
  styleUrls: ['./frame-blank-config.component.scss'],
})
export class AtwFrameBlankConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any; // xem đang ở page hay admin
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;
  isCollapsed: boolean = false;

  public urlBackgroundImage = ''; // Giá trị đường dẫn của background-image

  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
  };
  public currentViewAll: any = {};
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 2,
    },
    {
      title: 'nang_cao',
      index: 3,
    }
  ];

  animation: any = {};
  effect_hover = [];
  customize = [];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator: VhEventMediator,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Kiểm tra nếu chưa có config thì thêm để người dùng không cần xóa thêm lại
      if (!this.config.hasOwnProperty('position_onscroll')) {
        this.config.position_onscroll = {
          'type': 0,
          'top': 0
        };
      }

      // Cố định vị trí phần tử con trong khung
      if (!this.config.hasOwnProperty('fixed_children_position')) {
        this.config.fixed_children_position = false;
      }


      // phần này get dữ liệu json
      forkJoin([
        this.http.get('assets/data/effects/frame-blank.json')
      ]).subscribe(([effects]: any) => {
        this.effect_hover = effects;
      })
    }
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }

  ngOnChanges() {
    this.config.filter ??= {};
    this.config.filter.filter_opacity ??= 100;
    this.config.filter.filter_grayscale ??= 0;
    this.config.filter.filter_contrast ??= 100;
    this.config.filter.filter_blur ??= 0;
    this.config.filter.filter_saturate ??= 100;
    this.config.filter.filter_hue_rotate ??= 0;
    this.config.filter.filter_brightness ??= 100;

    if (!this.config.hasOwnProperty('background-color')) {
      this.config['background-color'] = {
        "gradient_arr": [
          "rgb(0, 0, 255)",
          "rgb(255, 255, 0)"
        ],
        "background": "#8c52ff",
        "gradient_check": false,
        "value_range": 1,
        "gradient_type": "linear-gradient",
        "value_parameter": 100,
        "gradient_direction": ""
      };
    }
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['frame-blank']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['frame-blank']['background-image'] = "none";
    }
    this.updateObject();
  }

  /**Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector(
        '.container-color .active'
      ) as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      const data_background = this.class['frame-blank']
      data_background['background-color'] = bgColor.bgColor;
      data_background['background-color'] = `rgba(${this.hexToRGB(data_background['background-color'])}, ${this.config['background-color'].value_range})`;
      this.updateObject();
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Get class active của element khi click chọn hướng phối màu.
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      var activeGradient = document.querySelector('.active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['frame-blank']['background-image'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện gán giá trị background-image khi có thay đổi
   *
   */
  handleSetBackgroundImage() {
    this.class['frame-blank']['background-image'] = this.class['frame-blank'][
      'background_image_restore'
    ] = `url(${this.urlBackgroundImage})`;
    this.updateClass();
  }

  /** Hàm thực hiện xử lí khi chuyển lựa chon background
   *
   * @param event
   */
  handleSetBackground(event) {
    let frameBlank = this.config['frame-blank'];
    if (event === 'color') {
      if (this.class['frame-blank']['background-color'] == 'transparent') {
        this.class['frame-blank']['background-color'] =
          frameBlank['background_color_restore'];
      }
      this.class['frame-blank']['background-image'] = 'none';
    }
    if (event === 'image') {
      if (frameBlank['background-image'] == 'none') {
        this.class['frame-blank']['background-image'] = `url("${this.config['frame-blank']['background_image_restore']}")`
        // Xử lí cắt chuỗi background-image
        let backgroundImage = this.class['frame-blank']['background-image'];
        const startIndex = backgroundImage.indexOf('(') + 1; // Tìm vị trí bắt đầu của phần tử aaa
        const endIndex = backgroundImage.lastIndexOf(')');
        this.urlBackgroundImage = backgroundImage.substring(
          startIndex,
          endIndex
        ); // Cắt phần tử url từ vị trí bắt đầu đến kết thúc
      }
      // this.class['frame-blank']['background-color'] = 'transparent';
    }
    setTimeout(() => {
      this.updateClass();
      this.updateConfig();
    }, 0);
  }

  /** Hàm thực hiện xử lí khi có thay đổi trường background-color
   *
   */
  handleSetBackgroundColor(event) {
    this.config['frame-blank']['background_color_restore'] = this.class[
      'frame-blank'
    ]['background-color'] = event;
  }


  /** Hàm sẽ thực hiện disable các option khi lựa chọn tải ảnh nền cho frame
   *
   * @param valueItem
   * @returns
   */
  checkDisableUploadImage(valueItem: any) {
    if (this.config['frame-blank'].is_upload_image === valueItem) return false;
    return true;
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-blank']['width'] = event.width + 'px';
    if (event.height) this.class['frame-blank']['min-height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {
        if (this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
          // nếu là frame-blank con của banner thì bắn sự kiện frame-banner set lại z-index frame-blank con
          // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
          this.vhEventMediator.notifyOnConfigChanged({
            status: 'config-changed',
            code: this.objectChoosing.id_object,
          });
        }
      });
  }

  //Hàm update config
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {
        // console.log('updateObject', bool);
        if (this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
          // nếu là frame-blank con của banner thì bắn sự kiện frame-banner set lại z-index frame-blank con
          // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
          this.vhEventMediator.notifyOnConfigChanged({
            status: 'config-changed',
            code: this.objectChoosing.id_object,
          });
        }
      });
  }

  /**
  * Cập nhật staticdata vào database.
  */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then(
        (bool) => {
          // console.log('updateObject', bool);
          if (this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
            // nếu là frame-blank con của banner thì bắn sự kiện frame-banner set lại z-index frame-blank con
            // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
            this.vhEventMediator.notifyOnConfigChanged({
              status: 'config-changed',
              code: this.objectChoosing.id_object,
            });
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        // console.log('updateObject', bool);
        if (this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
          // nếu là frame-blank con của banner thì bắn sự kiện frame-banner set lại z-index frame-blank con
          // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
          this.vhEventMediator.notifyOnConfigChanged({
            status: 'config-changed',
            code: this.objectChoosing.id_object,
          });
        }
      })
  }

  handleChangeContainer(event: any) {
    this.config['frame-blank__boundary']['is_container'] = event
    if (event) {
      this.class['frame-blank__boundary']['width'] = '75%';
      this.class['frame-blank__boundary']['position'] = 'relative';
    } else {
      this.class['frame-blank__boundary']['width'] = '100%';
      this.class['frame-blank__boundary']['position'] = 'unset';

    }
    this.updateClass();
    this.updateConfig();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[1])
  }

  /**
 * Hàm này thay đổi box-shadow giữa có hiệu ứng và không có hiệu ứng.
 * Khi gọi hàm này thì hiệu ứng hover hiển thị box-shadow sẽ bị disable.
 * Ngược lại thì thì hiệu ứng hover hiển thị box-shadow enable.
 */
  onChangeShadow() {
    if (this.config['box-shadow']['shadow_check'] === false) {
      this.config['box-shadow']['offset_x'] = 0;
      this.config['box-shadow']['offset_y'] = 0;
      this.config['box-shadow']['blur_radius'] = 0;
      this.config['box-shadow']['shadow_color'] = '#333';
    }
    this.class['frame-blank']['box-shadow'] = `${this.config['box-shadow']['offset_x']}px ${this.config['box-shadow']['offset_y']}px ${this.config['box-shadow']['blur_radius']}px ${this.config['box-shadow']['shadow_color']}`;

  }

  /**
   * Hàm bật tắt scroll trong frame-blank.
   * @param event true: bật scroll cố định height, false: tắt scroll bỏ cố định height
   */
  toggleScrollFrame(event) {
    if (!this.config['-webkit-scrollbar'])
      this.config['-webkit-scrollbar'] = {
        "is_scroll": false,
        "width": "10px",
        "background_color": "#e7e7e7",
        "thumb_background_color": "#666666",
        "border_radius": "8px"
      };

    this.config['-webkit-scrollbar']['is_scroll'] = event;

    if (this.config['-webkit-scrollbar']['is_scroll']) {
      this.class['frame-blank']['overflow'] = 'hidden auto';
      this.class['frame-blank']['height'] = this.class['frame-blank']['min-height'];
    } else {
      delete this.class['frame-blank']['overflow'];
      delete this.class['frame-blank']['height'];
    }

    this.updateObject();
  }
}
